<template>
    <section class="section a-section a-section--fullheight">
        <div class="container">
            <div
                class="columns is-mobile is-multiline"
                :class="{'is-centered':images.length === 0}"
            >
                <div class="column is-12">
                    <div class="a-flex a-flex--justifyContent-flexStart">
                        <p><b>+ Rozładunek</b><br /><small>Dodaj dokumenty. Pozwoli to szybciej rozliczyć.</small></p>
                    </div>
                </div>
                <div class="column is-12">
                    <hr class="a-hr a-hr--noMargin" />
                </div>
                <div
                    class="column is-6 is-relative"
                    v-for="(image, idx) in images"
                    :key="idx"
                >
                    <label
                        :for="`photo_${idx}`"
                        class="a-checkbox__label"
                    >
                        <figure class="image a-image a-image--square a-image--borderRadius">
                            <img :src="image.image" alt="">
                        </figure>
                        <input
                            type="checkbox"
                            :id="`photo_${idx}`"
                            class="a-checkbox__input"
                            :value="image.id"
                            v-model="checkedPhotos"
                        >
                        <div class="a-checkbox__labelWrapper">
                            <div class="a-checkbox__labelContent">
                                <icon-remove />
                            </div>
                        </div>
                    </label>
                    <br />
                    <document-types
                        @document-type-change="changeDocumentTypeHandler(image.id, $event)"
                        :document-type-id="parseInt(image.documentTypeId) || -1"
                    />
                </div>
                <div class="column is-6">
                    <button
                        class="button a-button--addPhoto a-button--square"
                        @click="$router.push({ name: 'unloading-photo', params: { token } })"
                    >
                        <span class="a-flex a-flex--flexDirection-column a-button__innerBorder a-button__square">
                            <icon-photo />
                            Dodaj zdjęcia dokumentów
                        </span>
                    </button>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="columns">
                <div class="column">
                    <br />
                    <button
                        class="button a-button a-button--dark a-button--marginBottom"
                        @click="remove"
                        v-if="checkedPhotos.length > 0"
                    >
                        <icon-remove-black />
                        Usuń wybrane zdjęcia
                    </button>
                    <div class="a-flex">
                        <label class="a-radio">
                            <input
                                type="radio"
                                class="a-radio__input"
                                v-model="status"
                                value="discharged"
                            >
                            <div class="a-radio__labelWrapper">
                                <div class="a-radio__labelContent">
                                    <icon-remove />
                                </div>
                            </div>
                            <span>Rozładowano</span>
                        </label>
                        <label class="a-radio">
                            <input
                                type="radio"
                                class="a-radio__input"
                                v-model="status"
                                value="waste"
                            >
                            <div class="a-radio__labelWrapper">
                                <div class="a-radio__labelContent">
                                    <icon-remove />
                                </div>
                            </div>
                            <span>Odrzut</span>
                        </label>
                    </div>
                    <div v-if="status === 'waste'">
                        <p class="a-label">
                            Komentarz
                        </p>
                        <textarea
                            v-model="message"
                            class="textarea"
                        ></textarea>
                    </div>
                    <br />
                    <button
                        class="button is-primary a-button a-button--medium"
                        @click="submit"
                    >
                        Wyślij dokumenty i status
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import IconRemove from '@/components/icons/Remove'
import IconRemoveBlack from '@/components/icons/RemoveBlack'
import IconPhoto from '@/components/icons/Photo'
import DocumentTypes from '@/components/DocumentTypes'
export default {
    name: 'UnloadingPhotos',
    components: {
        IconRemove,
        IconRemoveBlack,
        IconPhoto,
        DocumentTypes
    },
    computed: {
        images() {
            return this.$store.getters.unloadingPhotos
        },
        token() {
            return this.$store.getters.token
        },
        status: {
            get() {
                return this.$store.getters.unloadingStatus
            },
            set(status) {
                this.$store.commit('SET_UNLOADING_STATUS', status)
            }
        }
    },
    data() {
        return {
            checkedPhotos: [],
            message: ''
        }
    },
    methods: {
        changeDocumentTypeHandler(id, documentTypeId) {
            this.$store.dispatch('setUnloadingPhotoDocumentType', {
                id,
                documentTypeId
            })
        },
        remove() {
            this.$store.dispatch('removeUnloadingPhoto', this.checkedPhotos).then(() => {
                this.checkedPhotos = []
            })
        },
        submit() {
            this.$store.dispatch('submitUnloading', {
                status: this.status,
                message: this.message
            }).then(() => {
                this.$store.dispatch('setEmptyInfo', 'Wysłano')
                this.$router.push({ name: 'empty' })
            }).catch(e => {
                console.error(e)
            })
        }
    }
}
</script>
